export default {
  text: '#202020',
  primary: '#d21437',
  secondary: '#d21437',
  background: 'white',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
